export const copyButtons = () => {
    const btns = document.querySelectorAll('[data-copy-text]')

    btns.forEach(btn => {
        btn.addEventListener('click', (ev) => {
            ev.preventDefault()

            // Copy the text inside the text field
            navigator.clipboard.writeText(ev.currentTarget.dataset.copyText)
            btn.dataset.copied = true
            setTimeout(() => {
                btn.dataset.copied = false
            }, 2000)
        })
    })
}
